/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { JobsControllerGetQueueDepthsQueryResponse, JobsControllerGetQueueDepths401, JobsControllerGetQueueDepths403 } from "../../models/jobsController/JobsControllerGetQueueDepths";

function getJobsControllerGetQueueDepthsUrl() {
  const res = { method: 'GET', url: `/api/v1/jobs/queue-depths` as const }  
  return res
}

/**
 * @description Returns the number of QUEUED jobs per job queue (std-job-queue, chat-job-queue, transfer-job-queue, cpu-job-queue), counted from the jobs table.
 * @summary Get job queue depths
 * {@link /api/v1/jobs/queue-depths}
 */
export async function jobsControllerGetQueueDepths(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<JobsControllerGetQueueDepthsQueryResponse, ResponseErrorConfig<JobsControllerGetQueueDepths401 | JobsControllerGetQueueDepths403>, unknown>({ method : "GET", url : getJobsControllerGetQueueDepthsUrl().url.toString(), ... requestConfig })  
  return res.data
}